import { api } from "./apiBaseQuery";

export const generalSettingsServices: any = api.injectEndpoints({
  endpoints: (builder) => ({
    // Endpoint para obtener todos los campos de configuración general (lista inicial)
    getGeneralSettings: builder.mutation({
      query: () => {
        return {
          url: `GeneralSettings`,
          method: "GET",
        };
      },
    }),
    // Endpoint para obtener las traducciones de un campo específico
    getGeneralSettingsTranslations: builder.mutation({
      query: (id: number) => {
        return {
          url: `Traducciones/GetTranslationsByKey?table=ConfiguracionesGenerales&id=${id}`,
          method: "GET",
        };
      },
    }),
    saveGeneralSettings: builder.mutation({
      query: (body) => {
        return {
          url: `GeneralSettings`,
          method: "PUT",
          body,
        };
      },
    }),
    resetGeneralSettings: builder.mutation({
      query: (clave) => {
        return {
          url: `GeneralSettings/Default?clave=${clave}`,
          method: "PUT",
        };
      },
    }),
  }),
});

export const {
  useGetGeneralSettingsMutation,
  useGetGeneralSettingsTranslationsMutation,
  useSaveGeneralSettingsMutation,
  useResetGeneralSettingsMutation,
} = generalSettingsServices;
